import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {SummaryComponent} from "./summary.component";

const routes: Routes = [
  {
    path: 'summary',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: SummaryComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SummaryRoutingModule { }
